
export const publicRoutes = [
  //{ path: '/info', element: <InfoPage /> },
  // Puedes agregar más rutas públicas aquí
]
